// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__PssnP","tab":"Tabs_tab__2Emyy","tabActive":"Tabs_tabActive__2jrWW"};